var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticStyle:{"padding":"30px"}},[_vm._v(" 最后 ")])}
var staticRenderFns = []

export { render, staticRenderFns }